import { SimpleChanges, Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChildren, QueryList, OnDestroy, AfterViewInit, OnChanges, ViewContainerRef, ViewChild } from '@angular/core';
import { NgForm, Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { SavedForm } from '../../classes/savedForm';
import { SavedFormsService } from '../../services/saved-forms.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from '../../services/dialog.service';
import { SavedFormIdentifier, Modules } from '../../utils/enumeration';
import { Statique } from '../../utils/statique';
import { SearchField } from '../../classes/searchField';
import { ConnectedUserComponent } from '../connectedUserComponent';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { Router, ActivatedRoute } from '@angular/router';
import { DatetimePickerComponent } from '../datetime-picker/datetime-picker.component';
import { ModalService } from '../modal/modal.service';
import { CompleterService, CompleterData } from 'ng2-completer';


@Component({
	selector: 'app-advanced-form-search',
	templateUrl: './advanced-form-search.component.html',
	styleUrls: ['./advanced-form-search.component.css']
})
export class AdvancedFormSearchComponent extends ConnectedUserComponent implements OnInit, OnDestroy, OnChanges {

	protected checkDirty: boolean;
	protected subscribedSelectedSf: Subscription;
	protected selectedSavedForm: SavedForm;

	public form: FormGroup;
	public listFields: Array<SearchField>;
	public listSelectedFields: Array<SearchField>;

	private applySearch: boolean = false;
	private viewInit: boolean = false;

	@Input() column?: string; // undefined | all | json
	@Input() initFields?: string; // undefined | all | json
	@Input() fieldsJsonFile: string;
	@Input() ebModuleNum: number; // numéro du module
	@Input() ebCompNum: number; // numéro du component
	@Input() editable?: boolean; // possibilité d'ajouter/supprimer les champs
	@Input() fieldsOnly?: boolean; // possibilité de définir les opérations (contains, equals, etc.)
	// @Input() paramFields: Array<SearchField>;
	@Input() initialListFields: any;
	@Input() initialListCategorie: any;

	@Input() module: number;

	@Output() searchHandler = new EventEmitter<any>();
	compagnieNum: number;

	@ViewChildren('autocomplete') autocompChildren: QueryList<AutocompleteComponent>;
	@ViewChildren('datetimepicker') datetimePickerChildren: QueryList<DatetimePickerComponent>;
	
	suggestionsDfr: CompleterData;

	constructor(
		protected fb: FormBuilder,
		private completerService: CompleterService,
		protected savedFormsService: SavedFormsService,
		protected dialogService: DialogService,
		public fieldSelector: ElementRef,
		public router: Router,
		private activatedRoute: ActivatedRoute,
		private modalService: ModalService
	) {
		super();

		this.checkDirty = false;
		this.listSelectedFields = new Array<SearchField>();
		this.listFields = new Array<SearchField>();

	}

	ngOnInit() {
		var autocompleteUrlOrigin = `/listDfr`;
		let autocompleteUrlDfr = "/listDfr";
		autocompleteUrlDfr +=
			autocompleteUrlOrigin.indexOf("?") > 0 ? "&" : "?";
		autocompleteUrlDfr += `term=`;
		this.suggestionsDfr = this.completerService.remote(
			Statique.controllerPricing + autocompleteUrlDfr
		);
		if (typeof this.fieldsJsonFile == "undefined" && typeof this.initialListFields == "undefined")
			throw new Error("No json file for fields provided");

		if (typeof this.editable == "undefined")
			this.editable = true;
		if (typeof this.fieldsOnly == "undefined")
			this.fieldsOnly = true;
		if (typeof this.initialListFields == "undefined") {
			this.initialListFields = require("../../../assets/ressources/jsonfiles/" + this.fieldsJsonFile + ".json");
		}
		// else if(!this.initialListFields){
		// 	this.initialListFields = this.paramFields;
		// }

		// this.removeAllFields();
		this.initFormData();

		document.addEventListener('savedsearch', function (e) {
			event.preventDefault();
			event.stopPropagation();

			let sf = new SavedForm();
			sf = e.detail;

			this.loadSavedForm(sf);
		}.bind(this), false);

		this.activatedRoute.queryParams.subscribe(params => {
			let sf = new SavedForm();
			sf.ebCompNum = params["ebCompNum"];
			sf.ebModuleNum = params["ebModuleNum"];
			sf.ebSavedFormNum = params["ebSavedFormNum"];
			sf.ebUserNum = params["ebUserNum"];
			sf.formName = params["formName"];
			sf.formValues = params["formValues"];
			sf.url = params["url"];

			this.loadSavedForm(sf);

		});
	}

	afficherCompEtab(fieldName): boolean {
		var result: boolean = true;
		if (fieldName == 'chargeurEbEtablissementNum' || fieldName == 'ebCompagnieNum') {
			if (this.userConnected.role == this.UserRole.PRESTATAIRE) {
				if (fieldName == 'chargeurEbEtablissementNum' && this.compagnieNum)
					result = true;
				else if (fieldName == 'ebCompagnieNum')
					result = true;
			}
			else
				result = false;
		}

		return result;
	}

	loadSavedForm(sf) {
		if (sf != null && sf.ebModuleNum == this.ebModuleNum && sf.ebCompNum == this.ebCompNum && sf.ebUserNum == this.userConnected.ebUserNum) {
			this.selectedSavedForm = sf;
			this.applySearch = true;
			this.fillFormWithSf(sf);
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes["initialListFields"] && changes["initialListFields"].currentValue) {
			this.removeAllFields();
			this.initFormData();
		}
	}

	addField() {
		let fieldIndex = this.getFieldSelector(".field-selector").selectedIndex;
		fieldIndex = Number(fieldIndex);

		if (this.listFields.length > fieldIndex && fieldIndex >= 0) {
			this.form.addControl(this.listFields[fieldIndex].name, this.fb.control(""));
			this.listSelectedFields.push(this.listFields[fieldIndex]);
			this.listFields.splice(fieldIndex, 1);
		}
	}

	deleteField(index) {
		if (this.listSelectedFields.length > index && index >= 0) {
			this.listFields.push(this.listSelectedFields[index]);
			this.form.removeControl(this.listSelectedFields[index].name);
			this.listSelectedFields.splice(index, 1);
		}
	}

	getFieldSelector(selector: string) {
		return this.fieldSelector.nativeElement.querySelectorAll(selector)[0];
	}

	// methode pour instancier l'objet du formulaire et charger les données passées en param
	initFormData() {
		this.viewInit = false;

		if (this.initialListFields && typeof this.initFields !== "undefined") {
			if (this.initFields === "all") {
				this.listSelectedFields = Statique.cloneObject(this.initialListFields);
			}
			else {
				this.listSelectedFields = JSON.parse(this.initFields);
			}
		}

		// init form
		this.form = this.fb.group({});
		if (this.initialListFields) {
			let formFields = {};

			this.initialListFields.forEach(it => {
				let exists = this.listSelectedFields.some(sit => {
					if (it.name === sit.name) {
						this.form.addControl(sit.name, this.fb.control(""))
						return true;
					}
				});
				if (!exists)
					this.listFields.push(it);
			});
		}

		this.viewInit = true;
	}

	// sauvegarder le formulaire
	async saveForm() {
		let sf = new SavedForm();

		sf.ebModuleNum = this.ebModuleNum;
		sf.ebCompNum = this.ebCompNum;
		sf.ebUser = this.userConnected;

		if (this.selectedSavedForm) {
			sf.ebSavedFormNum = this.selectedSavedForm.ebSavedFormNum
			sf.formName = this.selectedSavedForm.formName;
			sf.dateAjout = this.selectedSavedForm.dateAjout;
		}

		if (this.listSelectedFields.length > 0) {
			let fieldSelector = null;
			try {
				if (sf.ebSavedFormNum)
					await this.modalService.confirmPromise("Saved search", `Do you want to replace the old saved search ? (${sf.formName})`);
			} catch (e) {
				sf.formName = null;
				sf.ebSavedFormNum = null;
				sf.dateAjout = null;
			}

			try {
				let result = await this.dialogService.input("Save search", 'Please name this search before saving it.', sf.formName);
				if (!result) return;

				sf.formName = "" + result;
				this.listSelectedFields.forEach(field => {
					fieldSelector = this.getFieldSelector(".operator-" + field.name);
					if (fieldSelector)
						field.operator = fieldSelector.value;

					if (field.type == "autocomplete") {
						this.autocompChildren.forEach(cmp => {
							if (cmp.name == field.name) {
								field.default = cmp.selectedItem;
							}
						});
					}
					else if (field.type == "date") {
						this.datetimePickerChildren.forEach(cmp => {
							if (cmp.name == field.name) {
								field.default = Statique.formatDate(cmp.date);
							}
						});
					}
					else {
						field.default = this.getFieldSelector("[name=" + field.name + "]").value;
					}
					// field.default = this.form.controls[field.name].value; // for some reason, it always gives empty value
				});


				sf.formValues = JSON.stringify(this.listSelectedFields);
				sf.url = this.router.url;

				this.savedFormsService.saveSavedForm(sf).subscribe(function (res) {
					this.selectedSavedForm = res;
					this.savedFormsService.notifyComponentSavedForms(res);
				}.bind(this));

				this.clearAllFields();
			}
			catch (e) {
				// on modal dismiss
			}
		}
	}

	removeAllFields() {		
		this.listSelectedFields = this.listSelectedFields.filter(field => {			
			this.form.removeControl(field.name);
			this.listFields.push(field);
			return false;
		});
	}

	clearAllFields() {
		this.removeAllFields();
		this.initFormData();
		this.searchHandler.emit({});
	}

	// methode de remplissage du formulaire
	async fillFormWithSf(sf: SavedForm) {
		
		await this.waitUntilViewIsLoaded();

		if (sf && this.ebCompNum == sf.ebCompNum && this.ebModuleNum == sf.ebModuleNum) {
			let parsedValues: Array<SearchField> = JSON.parse(sf.formValues),
				controls = this.form.controls;						
			
			this.listSelectedFields = this.listSelectedFields.filter((field, i) => {				
				if (controls[field.name] && (this.checkDirty && !controls[field.name].dirty || !this.checkDirty)) {										
					this.form.removeControl(field.name);
					this.listFields.push(field);
				}
				else return true;
			});

			parsedValues.forEach(field => {
				
				if (controls[field.name] && (this.checkDirty && !controls[field.name].dirty || !this.checkDirty)) {					
					// si le champs existe déjà, on remplace le champs existant par le nouveau
					let exists = this.listSelectedFields.some((it, i) => {						
						if (it.name == field.name) {
							this.listSelectedFields.splice(i, 1);
							this.form.removeControl(field.name);
							this.form.addControl(field.name, this.fb.control(""));
							this.listSelectedFields.push(field);
							return true;
						}
					});
					
					if (!exists) {						
						this.listFields.some((it, i) => {
							if (it.name == field.name) {
								this.listFields.splice(i, 1);
								this.form.addControl(field.name, this.fb.control(""));
								this.listSelectedFields.push(field);
								return true;
							}
						});
					}
				} else if (!controls[field.name]) {
					
					// si le champs n'existe pas encore, alors on l'ajoute dans le dropdown
					this.form.addControl(field.name, this.fb.control(""));
					this.listSelectedFields.push(field);
					this.listFields.some((it, i) => {
						if (field.name == it.name) {
							this.listFields.splice(i, 1);
							return true;
						}
					});
				}
				
				if(field.name == "ebCompagnieNum" && field.default){
					this.compagnieNum = Number(field.default);
				}
			});
						
			await this.waitUntilViewIsLoaded();
			
			if (this.applySearch) {
				this.applySearch = false;
				this.search();
			}
		}
	}

	async waitUntilViewIsLoaded() {

		let hasAutocompleteField = this.listSelectedFields.find(it => it.type == "autocomplete") ? true : false;
		let totalTimeout = 0;
		do {
			totalTimeout += 200;
			await Statique.waitForTimemout(200);
		} while (!this.viewInit && hasAutocompleteField && !this.autocompChildren && totalTimeout < 15000);
	}

	stringify(data) {
		if (data)
			return JSON.stringify(data);
		return null;
	}

	search() {
		if (this.listSelectedFields && this.listSelectedFields.length > 0) {
			let result = {}, value = null, operator = null;


			this.listSelectedFields.forEach(field => {
				value = null;
				operator = null;
				if (!this.fieldsOnly)
					operator = this.getFieldSelector(".operator-" + field.name).value;

				if (field.type == "autocomplete") {
					this.autocompChildren.forEach(cmp => {
						if (cmp.name == field.name) {
							value = cmp.selectedItem;
						}
					});
				}
				else if (field.type == "date") {
					this.datetimePickerChildren.forEach(cmp => {
						if (cmp.name == field.name) {
							value = Statique.formatDate(cmp.date);
						}
					});
				}
				else if (field.type == "autocomplete2") {
					value = field.default;
				}
				else {
					value = this.getFieldSelector("[name=" + field.name + "]").value;
					if (value == "") { value = null }
				}

				if (!this.fieldsOnly)
					result[field.name] = { value, operator };
				else
					result[field.name] = value;

			});

			this.searchHandler.emit(result);
		}
	}

	ngOnDestroy() {
		if (this.subscribedSelectedSf)
			this.subscribedSelectedSf.unsubscribe();
	}
}




// WEBPACK FOOTER //
// ./src/app/shared/advanced-form-search/advanced-form-search.component.ts